// ---------------------------------------------------------------------------
// Guide telemetry. Fire and forget.
//
// This is how we find out that everybody dies on step 4, and how a guide broken
// by a renamed button surfaces within a day instead of a quarter. It must never
// affect the guide: every failure is swallowed, and a missing endpoint (the
// backend half lands in Phase 1) disables reporting for the rest of the session
// rather than logging on every step.
// ---------------------------------------------------------------------------

import axios from '../utils/axios';

export const COACH_TELEMETRY = {
  guideStarted: 'guide_started',
  stepShown: 'step_shown',
  stepAdvanced: 'step_advanced',
  stepSkipped: 'step_skipped',
  stepStalled: 'step_stalled',
  guidePaused: 'guide_paused',
  guideCompleted: 'guide_completed',
  guideAbandoned: 'guide_abandoned',
  coachOffered: 'coach_offered',
  coachOfferAccepted: 'coach_offer_accepted',
};

let disabled = false;

export function reportCoachEvent(event, { guideId, stepId, meta } = {}) {
  if (disabled || !event) return;
  axios
    .post('/api/v1/accounts/onboarding/event/', {
      event,
      guide_id: guideId || null,
      step_id: stepId || null,
      meta: meta || {},
    })
    .catch((err) => {
      if (err?.response?.status === 404) disabled = true;
    });
}
